export default function CollapseOne() {
  return (
    <div className="flex flex-col my-2 gap-4">
      <p>Hipersensibilidad a la sustancia activa o a cualquiera de sus excipientes.</p>
    </div>
  )
    ;
}